const translations = {
  'fields.name': 'Nome',
  'fields.status': 'Status',
  'fields.description': 'Descrição',
  'fields.fieldValues': 'Campo adicionais',
  'fields.place': 'Destino',
  'fields.priority': 'Prioridade',
  'fields.user': 'Responsável',
  'fields.createdBy': 'Responsável',
  'fields.group': 'Grupo',
  'fields.documents': 'Documentos',
  'fields.asset': 'Ativos',
  'fields.scheduling': 'Agendamento',
  'fields.events': 'Eventos',
  'fields.address': 'Endereço',
  by: 'por',
  anonymous: 'Anônimo',
  yes: 'sim',
  no: 'não',
  operation: 'Operação',
  date: 'Data',
  operationDetails: 'Detalhes da operação',
  seeDetails: 'Ver detalhes',
  'operations.create': 'Criação',
  'operations.update': 'Modificação',
  'operations.remove': 'Remoção',
  'operations.notSupported': 'Não suportada'
}

export default translations
